import { useExperimentVariant } from 'src/utils/experimentNew'
import { Experiments } from '../constants'

/**
 * control: existing onboarding — auto-generates a first artwork inside the
 * onboarding modal; user never touches the real generator before activation.
 * treatment: new user is routed to /generator/image, onboarding reveals a
 * pre-baked first prompt instead of auto-generating, and on close the prompt
 * is injected into the real generator with a tooltip on the generate button.
 */
type Variant = 'control' | 'treatment'

const EXPERIMENT_KEY = Experiments.OnboardingInGenerationPanel

export function useOnboardingInGenerationPanelExperiment() {
  const { value, enableExposure } = useExperimentVariant<Variant>(
    EXPERIMENT_KEY,
    'control',
    { autoExpose: false },
  )

  return {
    variant: value,
    isTreatment: value === 'treatment',
    enableExposure,
  }
}
